import { render, staticRenderFns } from "./BikeHistory.vue?vue&type=template&id=1c9c86b2&lang=pug&"
import script from "./BikeHistory.vue?vue&type=script&lang=js&"
export * from "./BikeHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports